import { actions } from './actions'

const initialState = {
  productosSemanaHomeSelected: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function productosSemanaHomeReducer(state = initialState, action) {
  switch (action.type) {
    case actions.PRODUCTOS_SEMANA_HOME_SELECTED_LOAD_REQUESTED:
      return {
        ...state,
        productosSemanaHomeSelected: { ...state.productosSemanaHomeSelected, loading: true },
      }
    case actions.PRODUCTOS_SEMANA_HOME_SELECTED_LOAD_SUCCEEDED:
      return {
        ...state,
        productosSemanaHomeSelected: {
          ...state.productosSemanaHomeSelected,
          data: action.payload,
          loading: false,
        },
      }
    case actions.PRODUCTOS_SEMANA_HOME_SELECTED_LOAD_FILED:
      return {
        ...state,
        productosSemanaHomeSelected: {
          ...state.productosSemanaHomeSelected,
          loading: false,
          error: action.error,
        },
      }
    case actions.PRODUCTOS_SEMANA_HOME_UPDATE_SELECTED_REQUESTED:
      return {
        ...state,
        productosSemanaHomeSelected: { ...state.productosSemanaHomeSelected, loading: true },
      }
    case actions.PRODUCTOS_SEMANA_HOME_UPDATE_SELECTED_SUCCEEDED:
      return {
        ...state,
        productosSemanaHomeSelected: {
          ...state.productosSemanaHomeSelected,
          data: action.payload,
          loading: false,
        },
      }
    case actions.PRODUCTOS_SEMANA_HOME_UPDATE_SELECTED_FILED:
      return {
        ...state,
        productosSemanaHomeSelected: {
          ...state.productosSemanaHomeSelected,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
